import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

document.addEventListener("DOMContentLoaded", () => {
	let root = document.getElementById("root");
	ReactDOM.render(<App/>, root);
});